import { useAtom } from 'jotai';
import { deleteChildMutationAtom } from '../model/deleteChildMutationAtom';

export const useDeleteChild = () => {
    const [{ mutate, status, reset, error }] = useAtom(deleteChildMutationAtom);

    return {
        mutate,
        status,
        reset,
        errorMessage: error instanceof Error ? error.message : null,
    };
};
